import * as React from 'react';
import TickIcon from 'components/tick-icon/TickIcon';
const TickCell = ({ row }) => (React.createElement(TickIcon, { value: row.original.parsable }));
export default TickCell;
